var _circle, _circle2, _circle3, _circle4, _ellipse, _path, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvestorMembersZeroState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 205,
    height: 205,
    viewBox: "0 0 205 205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.549,
    cy: 41.5157,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 180.476,
    cy: 59.1768,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 201.956,
    cy: 68.2463,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 199.569,
    cy: 98.3181,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.8076,
    cy: 100.347,
    rx: 68.2583,
    ry: 67.6616,
    fill: "#787E8C",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M167.066 100.347C167.066 137.155 136.962 167.009 99.8076 167.009C62.6536 167.009 32.5493 137.155 32.5493 100.347C32.5493 63.539 62.6536 33.6853 99.8076 33.6853C136.962 33.6853 167.066 63.539 167.066 100.347Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.11489,
    cy: 69.6783,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.6662,
    cy: 181.851,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.1701,
    cy: 192.83,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 149.45,
    cy: 179.942,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 123.197,
    cy: 177.078,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 127.97,
    cy: 190.92,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 109.354,
    cy: 196.648,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 173.793,
    cy: 166.815,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 189.068,
    cy: 138.414,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 179.76,
    cy: 123.616,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 183.579,
    cy: 93.5447,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 191.455,
    cy: 77.3156,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 185.966,
    cy: 40.7997,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 73.3159,
    cy: 199.035,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 39.1865,
    cy: 194.262,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 43.9599,
    cy: 185.908,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 12.9331,
    cy: 147.722,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 19.8545,
    cy: 132.925,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 2.19333,
    cy: 94.4994,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 21.0478,
    cy: 64.6664,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 24.8667,
    cy: 22.4226,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 61.3823,
    cy: 6.19333,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 107.922,
    cy: 24.8093,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 133.936,
    cy: 18.8425,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M169.975 150.347C168.921 150.347 168.066 149.493 168.066 148.438C168.066 147.384 168.921 146.529 169.975 146.529",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.01221 117.65C7.0667 117.65 7.92153 116.795 7.92153 115.741C7.92153 114.686 7.0667 113.831 6.01221 113.831",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0317 22.4227C75.0862 22.4227 75.9411 21.5679 75.9411 20.5134C75.9411 19.4589 75.0862 18.6041 74.0317 18.6041",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M120.333 15.7399C119.279 15.7399 118.424 16.5947 118.424 17.6492C118.424 18.7037 119.279 19.5585 120.333 19.5585",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83057 166.934H15.7972M25.8211 155.836V157.388M37.5157 166.934H39.0671M25.8211 176.481V178.271M25.8211 180.658V186.982M21.4058 166.934C24.3892 166.934 25.9405 162.638 25.9405 162.638C25.9405 162.638 26.4178 166.934 30.2365 166.934C28.5181 166.934 26.0598 168.486 25.8211 171.588C25.8211 171.588 25.5432 169.048 24.6278 168.128C23.8635 167.359 21.4058 166.934 21.4058 166.934Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M178.209 30.0597L172.242 30.0597M162.099 45.8116L162.218 39.6063M150.524 30.0597L148.972 30.0597M162.099 20.7518L162.099 8.57985M166.634 30.0597C163.65 30.0597 162.099 34.3557 162.099 34.3557C162.099 34.3557 161.622 30.0597 157.803 30.0597C159.521 30.0597 161.98 28.5084 162.218 25.4057C162.218 25.4057 162.496 27.9459 163.412 28.8664C164.176 29.635 166.634 30.0597 166.634 30.0597Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M121.5 89H74.5C73.9477 89 73.5 88.5564 73.5 88.0041V65.5294C73.5 56.1303 83.1716 53.0706 88.3133 52.2248C89.2403 52.0723 89.6599 50.752 88.9737 50.1104C86.2143 47.5301 84.1795 44.5595 84.1795 39.5882C84.1795 33.4118 89.2051 26 98 26C106.795 26 111.821 33.4118 111.821 39.5882C111.821 44.9716 110.389 47.0705 106.278 50.7925C105.593 51.4124 106.027 52.5986 106.946 52.6957C117.457 53.8066 121.661 61.4093 122.482 65.4377C122.495 65.5003 122.5 65.5616 122.5 65.6254V88C122.5 88.5523 122.052 89 121.5 89Z",
    fill: "white",
    stroke: "#194590",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M77 149H40C39.4477 149 39 148.553 39 148.001V130C39 122.706 46.0735 120.128 50.2641 119.324C51.1826 119.148 51.6057 117.818 50.9447 117.156C48.9395 115.149 47.5 112.794 47.5 109C47.5 104 51.5 98 58.5 98C65.5 98 69.5 104 69.5 109C69.5 113.193 68.445 114.925 65.4504 117.734C64.7797 118.363 65.2122 119.548 66.1233 119.672C74.1074 120.757 77.3343 126.711 77.9822 129.91C77.9947 129.971 78 130.032 78 130.094V148C78 148.552 77.5523 149 77 149Z",
    fill: "white",
    stroke: "#787E8C",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M157.5 149H120.5C119.948 149 119.5 148.553 119.5 148.001V130C119.5 122.706 126.573 120.128 130.764 119.324C131.683 119.148 132.106 117.818 131.445 117.156C129.44 115.149 128 112.794 128 109C128 104 132 98 139 98C146 98 150 104 150 109C150 113.193 148.945 114.925 145.95 117.734C145.28 118.363 145.712 119.548 146.623 119.672C154.607 120.757 157.834 126.711 158.482 129.91C158.495 129.971 158.5 130.032 158.5 130.094V148C158.5 148.552 158.052 149 157.5 149Z",
    fill: "white",
    stroke: "#787E8C",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M74 77.0149H64C61.6667 76.8482 57 78.0149 57 84.0149C57 90.0149 57 93.1815 57 94.0149",
    stroke: "#787E8C",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M139 94.0076L139 84.0076C139.167 81.6742 138 77.0076 132 77.0076C126 77.0076 122.834 77.0076 122 77.0076",
    stroke: "#787E8C",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7926 83.5852C94.3746 83.5852 91.1627 82.2534 88.7454 79.8398C86.3282 77.4262 85 74.2106 85 70.7926C85 67.3746 86.3319 64.1627 88.7454 61.7454C91.159 59.3282 94.3746 58 97.7926 58C101.211 58 104.423 59.3319 106.84 61.7454C109.257 64.159 110.585 67.3746 110.585 70.7926C110.585 74.2106 109.253 77.4226 106.84 79.8398C104.426 82.257 101.211 83.5852 97.7926 83.5852ZM97.7926 58.1472C94.4151 58.1472 91.2399 59.4643 88.8521 61.8521C86.4643 64.2399 85.1472 67.4151 85.1472 70.7926C85.1472 74.1701 86.4643 77.3453 88.8521 79.7331C91.2399 82.1209 94.4151 83.4381 97.7926 83.4381C101.17 83.4381 104.345 82.1209 106.733 79.7331C109.121 77.3453 110.438 74.1701 110.438 70.7926C110.438 67.4151 109.121 64.2399 106.733 61.8521C104.345 59.4643 101.17 58.1472 97.7926 58.1472Z",
    fill: "#194590"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7926 80.2188C95.276 80.2188 92.9103 79.2401 91.1295 77.4594C89.3488 75.6787 88.3701 73.3129 88.3701 70.7964C88.3701 68.2798 89.3488 65.914 91.1295 64.1333C92.9103 62.3526 95.276 61.3739 97.7926 61.3739C100.309 61.3739 102.675 62.3526 104.456 64.1333C106.236 65.914 107.215 68.2798 107.215 70.7964C107.215 73.3129 106.236 75.6787 104.456 77.4594C102.675 79.2401 100.309 80.2188 97.7926 80.2188ZM97.7926 61.5137C95.3128 61.5137 92.9838 62.4777 91.2325 64.2326C89.4812 65.984 88.5136 68.3129 88.5136 70.7927C88.5136 73.2725 89.4776 75.6014 91.2325 77.3527C92.9838 79.104 95.3128 80.0716 97.7926 80.0716C100.272 80.0716 102.601 79.1077 104.353 77.3527C106.104 75.6014 107.072 73.2725 107.072 70.7927C107.072 68.3129 106.108 65.984 104.353 64.2326C102.601 62.4813 100.272 61.5137 97.7926 61.5137Z",
    fill: "#194590",
    stroke: "#194590"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7921 74.4461C95.7759 74.4461 94.1387 72.8089 94.1387 70.7927C94.1387 68.7765 95.7759 67.1392 97.7921 67.1392C99.8083 67.1392 101.446 68.7765 101.446 70.7927C101.446 72.8089 99.8083 74.4461 97.7921 74.4461ZM97.7921 67.2864C95.8605 67.2864 94.2858 68.8611 94.2858 70.7927C94.2858 72.7243 95.8605 74.299 97.7921 74.299C99.7237 74.299 101.298 72.7243 101.298 70.7927C101.298 68.8611 99.7237 67.2864 97.7921 67.2864Z",
    fill: "#194590",
    stroke: "#194590"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M103.444 73.0848C106.732 73.0848 109.397 70.4196 109.397 67.1319C109.397 63.8441 106.732 61.1789 103.444 61.1789C100.156 61.1789 97.4912 63.8441 97.4912 67.1319C97.4912 70.4196 100.156 73.0848 103.444 73.0848Z",
    fill: "#194590"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7926 83.5852C94.3746 83.5852 91.1627 82.2534 88.7454 79.8398C86.3282 77.4262 85 74.2106 85 70.7926C85 67.3746 86.3319 64.1627 88.7454 61.7454C91.159 59.3282 94.3746 58 97.7926 58C101.211 58 104.423 59.3319 106.84 61.7454C109.257 64.159 110.585 67.3746 110.585 70.7926C110.585 74.2106 109.253 77.4226 106.84 79.8398C104.426 82.257 101.211 83.5852 97.7926 83.5852ZM97.7926 58.1472C94.4151 58.1472 91.2399 59.4643 88.8521 61.8521C86.4643 64.2399 85.1472 67.4151 85.1472 70.7926C85.1472 74.1701 86.4643 77.3453 88.8521 79.7331C91.2399 82.1209 94.4151 83.4381 97.7926 83.4381C101.17 83.4381 104.345 82.1209 106.733 79.7331C109.121 77.3453 110.438 74.1701 110.438 70.7926C110.438 67.4151 109.121 64.2399 106.733 61.8521C104.345 59.4643 101.17 58.1472 97.7926 58.1472Z",
    fill: "#194590",
    stroke: "#194590"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M87.3289 71.5358C86.5636 71.5358 85.8241 71.6388 85.1177 71.8302C85.1765 72.5403 85.2906 73.2319 85.4598 73.9052C86.0485 73.7213 86.6777 73.6219 87.3289 73.6219C90.7947 73.6219 93.6056 76.4329 93.6056 79.8987C93.6056 80.8553 93.3922 81.764 93.0059 82.5771C93.6498 82.8384 94.3231 83.0518 95.0148 83.2063C95.4526 82.1908 95.6954 81.076 95.6954 79.9023C95.6917 75.2813 91.9463 71.5358 87.3289 71.5358Z",
    fill: "#194590"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M107.112 62.1355C106.226 61.1826 105.199 60.3658 104.058 59.722C104.758 60.4357 105.192 61.4107 105.192 62.4887C105.192 64.6705 103.426 66.4365 101.244 66.4365C99.0621 66.4365 97.2961 64.6705 97.2961 62.4887C97.2961 60.3143 99.0511 58.552 101.222 58.5409C100.133 58.2356 98.9811 58.0737 97.7964 58.0737C97.6493 58.0737 97.5021 58.0773 97.3549 58.081C96.1371 59.159 95.3682 60.7337 95.3682 62.4887C95.3682 65.7375 97.9988 68.3681 101.248 68.3681C104.496 68.3681 107.127 65.7375 107.127 62.4887C107.123 62.371 107.116 62.2533 107.112 62.1355Z",
    fill: "#194590"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestorMembersZeroState);
export default __webpack_public_path__ + "static/media/investor-members-zero-state.215810f544e1796c80f72765b3090fdb.svg";
export { ForwardRef as ReactComponent };